import { withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: [!_ctx.dragIndication ? 'invisible' : '', "dropzone"],
    onDragover: _cache[1] || (_cache[1] = _withModifiers(ev => ev.target.classList.add('targeted'), ["prevent","self"])),
    onDragleave: _cache[2] || (_cache[2] = _withModifiers(ev => ev.target.classList.remove('targeted'), ["self"])),
    onDrop: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.$emit('droped')), ["prevent","self"]))
  }, null, 34))
}